
export class MailConnector {
host: string;
mailStoreType: string;
password: string;
port: string;
starttls: boolean | null;
username: string;
}

